import React from 'react';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import PermissionCheck from 'components/common/PermissionCheck';
import NonWorkingDaysListBrowser from './NonWorkingDaysListBrowser';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_NON_WORKING_DAYS_READ, ADMIN_NON_WORKING_DAYS_WRITE } from 'constants/rightsCodes';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { defaultNonWorkingDays, nonWorkingDaysModalVar } from '../../variables';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_NON_WORKING_DAYS_WRITE} withForbiddenPage={false}>
          <IconButton
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Add')}
            onClick={() => nonWorkingDaysModalVar({ open: true, item: defaultNonWorkingDays })}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_NON_WORKING_DAYS_READ}>
        <NonWorkingDaysListBrowser />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
